/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MODERATION_MODE = "POST" | "PRE" | "SPECIFIC_SITES_PRE" | "%future added value";
export type ModerateNavigationContainer_settings = {
    readonly moderation: MODERATION_MODE | null;
    readonly forReviewQueue: boolean;
    readonly " $refType": "ModerateNavigationContainer_settings";
};
export type ModerateNavigationContainer_settings$data = ModerateNavigationContainer_settings;
export type ModerateNavigationContainer_settings$key = {
    readonly " $data"?: ModerateNavigationContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateNavigationContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateNavigationContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "moderation",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "forReviewQueue",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '5537f783cc39054fcd71216508583e6c';
export default node;
